{
	"title": "Attribut för infångad koldioxid",
	"buttonTitle": "Koldioxidinfångning och -lagring",
	"table": {
		"materialDescription": "Material",
		"quantity": "Kvantitet",
		"productGwpTotal": "Totalt produkt-GWP",
		"bundledCarbonReductions": "Bundlade koldioxidreduktioner",
		"remainingGwp": "Återstående GWP",
		"epdForPhysicalMaterial": "EPD för fysiskt material",
		"carbonPlantName": "Brevik, Norge"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "är den rättmätiga innehavaren av de rapporterade koldioxidreduktionerna."
	},
	"modal": {
		"title": "Koldioxidinfångning och -lagring",
		"description": "Carbon Capture and Storage (CCS) är en teknik som kan fånga in de koldioxidutsläpp (CO\u2082) som uppstår vid kalcineringsprocessen och vid användning av bränslen i ugnsdriften, vilket förhindrar att koldioxiden når atmosfären och lagrar den permanent under jord. Den infångade koldioxiden från Heidelberg Materials anläggning i Brevik, Norge, komprimeras och transporteras till en lagringsplats under Nordsjön. Anläggningen vid vår fabrik i Brevik kommer att fånga 400 000 ton CO\u2082 årligen.",
		"showLink": "Läs mer om processen för koldioxidinfångning",
		"buttonClose": "Stäng"
	},
	"footnote": "1) Koldioxidreduktioner kompenserar för stegen A1–A3 i cementets livscykelinventering."
}
